const TableContent = [
  {
    Vault: "#1",
    NoSubmisisions: "100",
    NoStash: "100",
    Genres: "100",
    Date: "22 Jan 2020, 00:00",
    FirstEdition: "22500",
  },
  {
    Vault: "#2",
    NoSubmisisions: "289",
    NoStash: "289",
    Genres: "289",
    Date: "09 Oct 2020, 00:00",
    FirstEdition: "24888",
  },
  {
    Vault: "#3",
    NoSubmisisions: "104",
    NoStash: "104",
    Genres: "104",
    Date: "01 May 2021, 00:00",
    FirstEdition: "24587",
  },
  {
    Vault: "#4",
    NoSubmisisions: "72",
    NoStash: "72",
    Genres: "72",
    Date: "27 Jun 2021, 00:00",
    FirstEdition: "445",
  },
  {
    Vault: "#5",
    NoSubmisisions: "1068",
    NoStash: "1068",
    Genres: "1068",
    Date: "05 Jun 2021, 00:00",
    FirstEdition: "78544",
  },
  {
    Vault: "#6",
    NoSubmisisions: "874",
    NoStash: "874",
    Genres: "874",
    Date: "19 Apr 2021, 00:00",
    FirstEdition: "4785",
  },
];
export { TableContent };
